import { render } from "./orariModal.vue?vue&type=template&id=36627102&scoped=true&ts=true"
import script from "./orariModal.vue?vue&type=script&lang=ts"
export * from "./orariModal.vue?vue&type=script&lang=ts"

import "./orariModal.vue?vue&type=style&index=0&id=36627102&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36627102"]])

export default __exports__